module.exports = __webpack_public_path__ + "img/logo.c237994f.png";